import {makeVar} from "@apollo/client";

export const groupedVar = makeVar([]);